import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('check-bold', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 9 7",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00998 2.21232L3.92835 6.49999C3.60182 6.84245 3.11203 6.84245 2.7855 6.49999L0.499781 4.10273C0.17325 3.76026 0.17325 3.24656 0.499781 2.9041C0.826311 2.56163 1.31611 2.56163 1.64264 2.9041L3.35366 4.69862L6.86713 1.01369C7.19366 0.671219 7.68345 0.671219 8.00998 1.01369C8.33652 1.363 8.33652 1.95889 8.00998 2.21232Z",
    fill: props.colors[0]
  }));
});